import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function activeModuleSelector(state: IInitialState) {
	return moduleStateSelector(state)?.activeModule;
}
